export enum LoggerLevel {
  Verbose = 'verbose',
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}
